export default class AlIFramePreviewController {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        // Initial binding values
        this.viewPort = 'desktop';
        this.content = '';
        this.marginTop = 30;

        this.internalViewPort = 'desktop';
        this.iFrameElement = null;

    }

    $onInit() {
        this._initWatchers();
    }

    $postLink() {
        const iFrameJqueryElement = this.element.find('iframe');
        this.iFrameElement = iFrameJqueryElement[0];

        iFrameJqueryElement.on('load', () => {
            this._updateIFrameProperties();
        });

        this._updateIFrameProperties();
    }

    _updateInternalViewport() {
        if (this.viewPort === 'mobile' || this.viewPort === 'tablet') {
            this.internalViewPort = _.clone(this.viewPort);
        } else {
            this.internalViewPort = 'desktop';
        }

        this._updateIFrameProperties();
    }

    _updateIFrameContent() {
        if (!this.iFrameElement) {
            return;
        }
        const contentWindow = this.iFrameElement.contentWindow.document;

        contentWindow.open();
        contentWindow.write(this.content);
        contentWindow.close();
    }

    _updateIFrameProperties() {
        if (!this.iFrameElement) {
            return;
        }

        let properties;

        switch (this.internalViewPort) {
            case 'mobile':
                properties = {
                    userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.1 Mobile/15E148 Safari/604.1',
                    width: '93.5%',
                    height: '88.5%'
                };
                break;
            case 'tablet':
                properties = {
                    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.169 Safari/537.36',
                    width: '93.5%',
                    height: '89.5%'
                };
                break;
            default:
                properties = {
                    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.169 Safari/537.36',
                    width: '100%',
                    height: '70vh'
                };
                break;
        }

        if (this.iFrameElement.contentWindow.navigator.userAgent !== properties.userAgent) {
            this.iFrameElement.contentWindow.navigator.__defineGetter__('userAgent', function () {
                return properties.userAgent;
            });
        }

        this.iFrameElement.setAttribute('style', `width: ${properties.width}; height: ${properties.height};`);

        if (this.internalViewPort === 'desktop') {
            this.iFrameElement.setAttribute('style', `width: ${properties.width}; height: ${this.iFrameElement.contentDocument.body.scrollHeight}px;`);
        }
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.viewPort,
            () => {
                this._updateInternalViewport();
            }
        )
        this.scope.$watch(
            () => this.content,
            () => {
                this._updateIFrameContent();
            }
        )
    }
}

AlIFramePreviewController.$inject = [
    '$scope',
    '$injector',
    '$element'
]



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-iframe-preview/controller.js